import { useParams, useNavigate } from "react-router-dom";
import { LabResultsReport } from "@/components/patient/LabResultsReport";
import { Breadcrumbs } from "@/components/Breadcrumbs";

export default function PacienteRelatorio() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return <div>Paciente não encontrado</div>;
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <LabResultsReport 
        patientId={id}
        onBack={() => navigate(`/app/pacientes/${id}`)}
      />
    </div>
  );
}
